import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { myInterceptor } from './http/credential.interceptor';
import { ErrorInterceptor } from './http/error.interceptor';
import { AuthenticationService } from './services/auth.service';
import { AuthGuard } from './guard/auth.guard';
import { ExternalService } from './services/external.service';
import { NotificationService } from '../pages/notification/notification.service';
import { ActiveLiquidationService } from '../pages/management-liquidation/active-liquidation.service';
import { CommonService } from './services/common.service';
import { LiquidationReportService } from '../pages/management-liquidation/liquidation-report/liquidation-report.service';
import { AssignReportService } from '../pages/management-liquidation/assign-report/assign-report.service';
import { MyLiqProcuService } from '../pages/management-liquidation/myLiq-procu/myLiq-procu.service';
import { LiquidationToBeAssignedService } from '../pages/management-liquidation/liquidation-to-be-assigned/liquidation-to-be-assigned.service';
import { ReporteService } from '../shared/services/reporte.service';
import { ToolBarNotificationsService } from '../shared/services/notifications.service';
import { ConsultaSojService } from '../pages/reporte/consulta-soj/consulta-soj.service';
import { MenuService } from './services/menu.service';
import { MenuStoreService } from './services/menu-store.service';
import { EmbargoListService } from '../pages/precautionary/embargo/embargo-list/embargo-list.service';
import { EmbargoCancellationService } from '../pages/precautionary/embargo/cancellation/embargo-cancellation.service';
import { UserManagementService } from '../pages/user-management/user-management.service';
import { EmbargoReassignService } from '../pages/precautionary/embargo/embargo-reassign/embargo-reassign.service';
import { AntLiquidationService } from '../pages/management-liquidation/ant-liquidation/ant-liquidation.service';
import { NotificationCidiService } from '../pages/notification-cidi/notification.service';
import { ProfileImageService } from '../shared/services/profile-image-service.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [
    CommonService,
    AuthGuard,
    AuthenticationService,
    { provide: HTTP_INTERCEPTORS, useClass: myInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ExternalService,
    EmbargoListService,
    EmbargoCancellationService,
    EmbargoReassignService,
    NotificationService,
    NotificationCidiService,
    ActiveLiquidationService,
    AntLiquidationService,
    LiquidationReportService,
    AssignReportService,
    MyLiqProcuService,
    MenuService,
    MenuStoreService,
    LiquidationToBeAssignedService,
    ReporteService,
    ToolBarNotificationsService,
    ConsultaSojService,
    UserManagementService,
    AntLiquidationService, 
    ProfileImageService
  ]
})
export class CoreModule { }
